import React from 'react'
import { message } from 'antd'
import { sum } from 'lodash';
import ChartBlock from './chartBlock'
import PieChart from './pieChart'
import ColumnChart from './columnChart'
import { toDataURL, renderNode, openPage } from './exportUtil'
import vmsService from './vmsService';

const getFansAnalyseRequest = (cidList) => {
  return vmsService.getFansAnalyse(cidList.join(',')).then((data: any) => {
    if (data.data) {
      return data.data
    }
    console.error(`data is error: ${JSON.stringify(data)}`)
    throw new Error('系统繁忙，请稍后再试')
  })
}

const getEndorsementListRequest = (cidList) => {
  return vmsService.getEndorsementList(cidList).then((data: any) => {
    if (Array.isArray(data.data)) {
      return data.data || []
    }
    console.error(`data is error: ${JSON.stringify(data)}`)
    throw new Error('系统繁忙，请稍后再试')
  })
};

const postExportData = (obj) => {
  return vmsService.postExportData(obj).then((data) => {
    if (data && data.data) {
      return data.data
    }
    console.error(`data is error: ${JSON.stringify(data)}`)
    throw new Error('系统繁忙，请稍后再试')
  })
};

const postExport = (obj) => {
  return vmsService.postExport(obj).then((data) => {
    if (data && data.data && data.data.url) {
      return data.data.url.replace(/http(s)?\:/, '')
    }
    console.error(`data is error: ${JSON.stringify(data)}`)
    throw new Error('系统繁忙，请稍后再试')
  })
};

function dataFormat(value, tgi, total) {
  const num = Number(value)
  const percent = total ? Math.round((num / total) * 10000) / 100 : 100
  return {
    value: num,
    percent,
    tgi: Math.round(Number(tgi) * 100)
  }
}

function getFansData({ data, labelFormat, isSort }) {
  const total = sum(data.map(({ value }) => Number(value))) || 0
  const chartData = data.map((item: any) => {
    let label = item.name
    if (typeof labelFormat === 'function') {
      label = labelFormat(item)
    }
    const {
      percent,
    } = dataFormat(item.value, item.tgi, total)
    let value = percent

    return {
      label,
      value
    }
  })

  if (isSort) {
    chartData.sort((a, b) => {
      return b.value - a.value
    })
  }

  return {
    chartData,
    total,
  }
}

function getCityData(cityData, total) {
  const chartData = cityData.map((item: any) => {
    const label = item.name
    const value = total ? Math.round((Number(item.value) / total) * 10000) / 100 : 100

    return {
      label,
      value
    }
  })
  return {
    chartData
  }
}

const renderFansChart = (ids) => {
  return getFansAnalyseRequest(ids).then((data) => {
    return data.map((item) => {
      const { chartData: sexData } = getFansData({
        data: item.sex || [],
        labelFormat: (item) => {
          return item.name === 'F' ? '女' : '男'
        },
        isSort: false
      })
      const { chartData: ageData } = getFansData({
        data: item.age || [],
        labelFormat: (item) => {
          return item.name.replace(/(?:\[|\])/g, '').replace(',', '~')
        },
        isSort: false
      })
      const { total: clTotal } = getFansData({
        data: item.city_level || [],
        labelFormat: undefined,
        isSort: false
      })

      const { chartData: cityData } = getCityData(item.city || [], clTotal)

      const { chartData: careerData } = getFansData({
        data: item.career || [],
        labelFormat: undefined,
        isSort: true
      })

      return {
        sexData,
        ageData,
        cityData,
        careerData,
      }
    })
  }).then((list) => {
    const dataList: any[] = []
    const childList: any[] = []
    const pList: any[] = []
    for (let i = 0; i < list.length; i += 1) {
      const item = list[i]
      const cid = ids[i]
      if (item && cid) {
        const { sexData, ageData, cityData, careerData } = item
        const resultData: any = {
          cid
        }
        dataList.push(resultData)
        pList.push(new Promise((resolve) => {
          childList.push(<PieChart key={cid} data={sexData} color={['#FF9893', '#9586D1']}
            onDataUrl={(chart) => {
              if (chart) {
                const dataURL = toDataURL(chart)
                if (dataURL) {
                  chart.destroy()
                  resultData.sexProfileImage = dataURL
                  resolve(resultData)
                }
              }
            }}
          />)
        }))
        pList.push(new Promise((resolve) => {
          childList.push(<ColumnChart key={cid} data={ageData} color={['#FF9893']}
            onDataUrl={(chart) => {
              if (chart) {
                const dataURL = toDataURL(chart)
                if (dataURL) {
                  chart.destroy()
                  resultData.ageProfileImage = dataURL
                  resolve(resultData)
                }
              }
            }}
          />)
        }))
        pList.push(new Promise((resolve) => {
          childList.push(<ColumnChart key={cid} data={cityData} color={['#9586D1']}
            onDataUrl={(chart) => {
              if (chart) {
                const dataURL = toDataURL(chart)
                if (dataURL) {
                  chart.destroy()
                  resultData.cityProfileImage = dataURL
                  resolve(resultData)
                }
              }
            }}
          />)
        }))
        pList.push(new Promise((resolve) => {
          childList.push(<ColumnChart key={cid} data={careerData} color={['#FF9893']}
            onDataUrl={(chart) => {
              if (chart) {
                const dataURL = toDataURL(chart)
                if (dataURL) {
                  chart.destroy()
                  resultData.professionProfileImage = dataURL
                  resolve(resultData)
                }
              }
            }}
          />)
        }))
      }
    }
    const remove = renderNode(childList)
    const pAll = Promise.all(pList).then(() => {
      return dataList
    })
    pAll.then(() => {
      remove()
    }).catch(() => {
      remove()
    })
    return pAll
  })
}

const renderEndorsementChart = (ids) => {
  return getEndorsementListRequest(ids).then((data) => {
    return data.map((item: any, index) => {
      const pItem = item.filter((endor: any) => {
        // if (endor.brandEndorseStatus === '已到期' || endor.endTime) {
        //   return false
        // }
        return true
      })
      // map[ids[index]] = pItem
      return pItem
    })
  }).then((list) => {
    const childList: any[] = []
    const pList: any[] = []
    for (let i = 0; i < list.length; i += 1) {
      const item = list[i]
      const cid = ids[i]
      if (item && cid) {
        pList.push(new Promise((resolve) => {
          childList.push(<ChartBlock
            key={cid}
            list={item}
            onDataUrl={(chart) => {
              const dataURL = toDataURL(chart)
              chart.destroy()
              resolve({
                cid,
                endorsementImage: dataURL,
              })
            }}
          />)
        }))
      }
    }
    const remove = renderNode(childList)
    const pAll = Promise.all(pList)
    pAll.then(() => {
      remove()
    }).catch(() => {
      remove()
    })
    return pAll
  })
}

export const exportPPT = (ids, style, projectId) => {
  return Promise.all([renderEndorsementChart(ids), renderFansChart(ids)]).then(([endorsementData, fansData]) => {
    const map = endorsementData.reduce((current, item) => {
      current[item.cid] = item
      return current
    }, {})

    return fansData.map((item) => {
      const cid = item.cid
      const endorsement = map[cid]
      return {
        ...item,
        ...endorsement,
      }
    })
  }).then((list) => {
    const cidList = list.map((item) => {
      return item.cid
    })
    return Promise.all(list.map((item) => {
      return postExportData(item)
    })).then(() => {
      return postExport({
        cidList,
        style,
        projectId,
      })
    })
  }).then((url) => {
    openPage(url)
  }).catch((err) => {
    message.error(err.message || err.msg || '系统繁忙，请稍后再试')
    throw err
  })
}
